/**
 * Review Status Mapping
 * Maps status codes to display labels and CSS class names
 */
export const REVIEW_STATUS_MAP: Record<string, { label: string; className: string }> = {
  '1': { label: 'Draft', className: 'yellow' },
  '2': { label: 'Scheduling', className: 'yellow' },
  '3': { label: 'Appointment Rejected', className: 'red' },
  '4': { label: 'Scheduled', className: 'yellow' },
  '5': { label: 'Pre-review in Progress', className: 'yellow' }, 
  '6': { label: 'Pre-review Completed', className: 'green' },
  '7': { label: 'Closed', className: 'gray' },
  '8': { label: 'Pending Decision', className: 'yellow' },
  '9': { label: 'Decision in Progress', className: 'yellow' },
  '10': { label: 'Decision Completed', className: 'green' },
  '11': { label: 'Decision Approved', className: 'green' },
  '12': { label: 'Decision Rejected', className: 'red' },
  '13': { label: 'Pre-review Rejected', className: 'red' },
};

/**
 * Helper function to get status info
 * @param status - Status code as string
 * @returns Object containing label and className
 */
export const getStatusInfo = (status: string) => {
  return REVIEW_STATUS_MAP[status] || { label: '', className: '' };
};

